import { Button, PlusIcon } from "melco-ui"
import { useNavigate } from "react-router-dom"
import { useAddHoop } from "../../hooks/hoops/useAddHoop";
import { useTranslation } from "react-i18next";

export const AddHoopActionButton: React.FC = () => {

    const navigate = useNavigate()
    const addHoops = useAddHoop();
    const { t } = useTranslation();
    return <>
        <Button
            icon={<PlusIcon />}
            onClick={async () => {

                let response = await addHoops();
                if (response && response.cloud_id)
                    navigate(`/system/managehoops/${response.cloud_id!}`)
                console.log(response)
            }}
            type="primary"
        >
            {t('managehoops.actions.add.button.title')}

        </Button>
    </>
}